<app-navbar [title]="pageFunction === 'edit' && editable ? 'Edycja: ' + pageTitle : pageTitle">
	<a routerLink="./history" class="btn btn-secondary me-3"> <i class="fas fa-history"></i> Historia </a>
	<button class="btn btn-warning me-3" *ngIf="pageFunction === 'edit' && !editable" (click)="confirmAsk()">
		Zatwierdź
	</button>
	<button class="btn btn-warning me-3" *ngIf="pageFunction === 'edit' && !editable" (click)="deleteAsk()">
		Usuń
	</button>
	<button
		class="btn btn-primary me-3"
		*ngIf="(pageFunction === 'edit' && editable) || pageFunction === 'add'"
		(click)="submit()"
	>
		Zapisz
	</button>
	<button class="btn btn-primary me-3" *ngIf="pageFunction === 'edit' && !editable" (click)="editUnlock()">
		Edycja
	</button>
	<a class="btn btn-danger" routerLink="/vehicles" [fragment]="data.id"> <i class="fa fa-car"></i> Pojazdy </a>
</app-navbar>

<div class="container my-4">
	<ul class="nav nav-tabs" id="myTab" role="tablist">
		<li class="nav-item" role="presentation">
			<a
				class="nav-link active"
				id="podstawowe-tab"
				data-bs-toggle="tab"
				href="#podstawowe"
				role="tab"
				aria-controls="podstawowe"
				aria-selected="false"
				>Podstawowe</a
			>
		</li>
		<li class="nav-item">
			<a
				class="nav-link"
				id="tourism-tab"
				data-bs-toggle="tab"
				href="#tourism"
				role="tab"
				aria-controls="tourism"
				aria-selected="false"
				>Parametry techniczne</a
			>
		</li>
		<li class="nav-item">
			<a
				class="nav-link"
				id="facilities-tab"
				data-bs-toggle="tab"
				href="#facilities"
				role="tab"
				aria-controls="facilities"
				aria-selected="false"
				>Wyposażenie techniczne</a
			>
		</li>
		<li class="nav-item">
			<a
				class="nav-link"
				id="service-tab"
				data-bs-toggle="tab"
				href="#service"
				role="tab"
				aria-controls="service"
				aria-selected="false"
				>Serwis</a
			>
		</li>
		<li class="nav-item">
			<a
				class="nav-link"
				id="equipments-tab"
				data-bs-toggle="tab"
				href="#equipments"
				role="tab"
				aria-controls="equipments"
				aria-selected="false"
				>Wyposażenie</a
			>
		</li>
		<li class="nav-item">
			<a
				class="nav-link"
				id="documents-tab"
				data-bs-toggle="tab"
				href="#documents"
				role="tab"
				aria-controls="documents"
				aria-selected="false"
				>Dokumenty</a
			>
		</li>
		<li class="nav-item">
			<a
				class="nav-link"
				id="task-tab"
				data-bs-toggle="tab"
				href="#task"
				role="tab"
				aria-controls="task"
				aria-selected="false"
				>Zadania</a
			>
		</li>
		<li class="nav-item">
			<a
				class="nav-link"
				id="confirmed-tab"
				data-bs-toggle="tab"
				href="#confirmed"
				role="tab"
				aria-controls="confirmed"
				aria-selected="false"
				>Historia Zatwierdzeń</a
			>
		</li>
		<li class="nav-item">
			<a
				class="nav-link"
				id="layout-tab"
				data-bs-toggle="tab"
				href="#layout"
				role="tab"
				aria-controls="layout"
				aria-selected="false"
				>Układ siedzeń</a
			>
		</li>
	</ul>
	<div class="my-4">
		<div class="tab-content" id="myTabContent">
			<div class="tab-pane fade active show" id="podstawowe" role="tabpanel" aria-labelledby="podstawowe-tab">
				<fieldset [disabled]="pageFunction !== 'add' && !editable">
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="type"
							[(ngModel)]="data.type"
							name="type"
							[ngClass]="{ error: this.errors.type }"
						>
							<option value="{{ item.id }}" *ngFor="let item of parameters.types">
								{{ item.name }}
							</option>
						</select>
						<label class="required" for="type">Typ</label>
					</div>
					<div class="form-floating mb-3">
						<input
							class="form-control"
							name="name"
							[(ngModel)]="data.name"
							id="name"
							[ngClass]="{ error: this.errors.name }"
						/>
						<label class="required" for="name">Kod pojazdu</label>
					</div>
					<div class="form-floating mb-3">
						<input
							class="form-control"
							name="registrationNumber"
							[(ngModel)]="data.registrationNumber"
							id="registrationNumber"
							[ngClass]="{
								error: this.errors.registrationNumber,
							}"
						/>
						<label class="required" for="registrationNumber">Nr rejestracyjny</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="status"
							[(ngModel)]="data.status"
							name="status"
							[ngClass]="{ error: this.errors.status }"
						>
							<option value="{{ item.id }}" *ngFor="let item of parameters.statuses">
								{{ item.name }}
							</option>
						</select>
						<label class="required" for="status">Status</label>
					</div>
					<div class="form-floating mb-3">
						<input
							class="form-control"
							name="nawigatorId"
							type="number"
							[(ngModel)]="data.nawigatorId"
							id="nawigatorId"
						/>
						<label for="registrationNumber">Nawigator ID</label>
					</div>
					<div class="form-floating mb-3">
						<input
							class="form-control"
							name="vinNumber"
							id="vinNumber"
							[(ngModel)]="data.vinNumber"
							maxlength="17"
						/>
						<label for="vinNumber">VIN (Numer Nadwozia)</label>
					</div>
					<div class="form-floating mb-3">
						<input
							class="form-control"
							type="number"
							name="yearOfProduction"
							id="yearOfProduction"
							[(ngModel)]="data.yearOfProduction"
							min="1980"
							max="2200"
							maxlength="4"
						/>
						<label for="productionYear">Rok produkcji</label>
					</div>
					<div class="form-floating mb-3">
						<input
							class="form-control"
							name="vehicleMark"
							id="vehicleMark"
							[(ngModel)]="data.vehicleMark"
						/>
						<label for="vehicleMark">Marka</label>
					</div>
					<div class="form-floating mb-3">
						<input
							class="form-control"
							name="vehicleModel"
							id="vehicleModel"
							[(ngModel)]="data.vehicleModel"
						/>
						<label for="">Model</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="exhaustStandards"
							[(ngModel)]="data.documents.exhaustStandards.standard"
							name="exhaustStandards"
						>
							<option value="brak">brak</option>
							<option value="euro5">Euro 5</option>
							<option value="euro6">Euro 6</option>
						</select>
						<label for="exhaustStandards">Emisja spalin</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="wrappingType"
							name="wrappingType"
							[(ngModel)]="data.wrappingType"
						>
							<option value="{{ item.id }}" *ngFor="let item of parameters.wrappingTypes">
								{{ item.name }}
							</option>
						</select>
						<label class="form-label" for="">Oklejenie</label>
					</div>
					<div class="form-check mb-3">
						<input
							class="form-check-input"
							type="checkbox"
							id="premium"
							name="premium"
							[checked]="data.premium"
							[(ngModel)]="data.premium"
						/>
						<label class="form-check-label" for="premium"> Premium </label>
					</div>
				</fieldset>
			</div>
			<div class="tab-pane fade" id="tourism" role="tabpanel" aria-labelledby="tourism-tab">
				<fieldset [disabled]="pageFunction !== 'add' && !editable">
					<div class="form-floating mb-3">
						<select class="form-control" id="busType" [(ngModel)]="data.busType" name="busType">
							<option value="{{ item.id }}" *ngFor="let item of parameters.busTypes">
								{{ item.name }}
							</option>
						</select>
						<label for="busType">Typ</label>
					</div>
					<div class="form-floating mb-3">
						<input class="form-control" name="seats" [(ngModel)]="data.seats" id="seats" required />
						<label class="col-form-label" for="seats">Ilość miejsc</label>
					</div>
					<div class="form-floating mb-3">
						<input
							class="form-control"
							type="number"
							name="fuelTanks"
							id="fuelTanks"
							[(ngModel)]="data.documents.fuelTanks.capacity"
						/>
						<label for="fuelTanks">Zbiornik paliwa</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="numberAxis"
							[(ngModel)]="data.documents.axis.number"
							name="numberAxis"
						>
							<option value="2">2</option>
							<option value="3">3</option>
							<option value="4">4</option>
						</select>
						<label for="numberAxis">liczba osi</label>
					</div>
				</fieldset>
			</div>
			<div class="tab-pane fade" id="service" role="tabpanel" aria-labelledby="service-tab">
				<fieldset [disabled]="pageFunction !== 'add' && !editable">
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="status"
							[(ngModel)]="data.status"
							name="status"
							[ngClass]="{ error: this.errors.status }"
						>
							<option value="{{ item.id }}" *ngFor="let item of parameters.statuses">
								{{ item.name }}
							</option>
						</select>
						<label class="required" for="status">Status</label>
					</div>
					<div class="form-floating mb-3">
						<input
							class="form-control"
							type="number"
							min="0"
							id="lastOilChange"
							name="lastOilChange"
							[(ngModel)]="data.lastOilChange"
						/>
						<label for="lastOilChange">Ostatnia wymiana oleju przy przebiegu [km]</label>
					</div>
					<div class="form-floating mb-3">
						<input
							class="form-control"
							type="number"
							min="0"
							id="oilChangeFrequency"
							name="oilChangeFrequency"
							[(ngModel)]="data.oilChangeFrequency"
						/>
						<label for="oilChangeFrequency">Częstotliwość wymiany oleju [km]</label>
					</div>
					<div class="form-floating mb-3">
						<input
							class="form-control"
							type="number"
							min="0"
							id="lastFiltersChange"
							name="lastFiltersChange"
							[(ngModel)]="data.lastFiltersChange"
						/>
						<label for="lastFiltersChange">Ostatnia wymiana filtrów [km]</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							type="text"
							id="tiresType"
							[(ngModel)]="data.tiresType"
							name="tiresType"
						>
							<option value="letnie">Letnie</option>
							<option value="zimowe">Zimowe</option>
							<option value="uniwersalne">Uniwersalne</option>
						</select>
						<label for="tiresType">Opony (letnie/zimowe/uniwersalne)</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="isClean"
							[(ngModel)]="data.documents.isClean.checkDocument"
							name="isClean"
						>
							<option value="1">Tak</option>
							<option value="2">Nie</option>
						</select>
						<label for="isClean">Status czystości</label>
					</div>
				</fieldset>
			</div>
			<div class="tab-pane fade" id="documents" role="tabpanel" arialabelledby="documents-tab">
				<span class="mb-3">
					<a
						class="link-primary"
						href="https://drive.google.com/drive/folders/1e7S2_PVHViovx6mayARH4Qh15TFYMA_Q"
						>Skany dokumentów</a
					>&nbsp;
				</span>
				<fieldset [disabled]="pageFunction !== 'add' && !editable">
					<!--<div class="card mb-3">
						<div class="card-body">
							<div class="card-text">
							<label class="form-label card-title">Karty</label>
								<div class="row">
									<div class="col-4">
										<div class="card">
											<div class="card-body">
												<div class="card-text">
													<div class="form-check mb-3">
														<input class="form-check-input" type="checkbox" id="boxCz" name="boxCz">
														<label class="form-check-label" for="boxCz">
															Alior
														</label>
													</div>
													<div class="row">
														<div class="col-6">
															<div class="form-floating mb-3">
																<input class="form-control" type="month" name="" id="" required>
																<label class="col-form-label" for="">Alior (ważna do:)</label>
															</div>
														</div>
														<div class="col-6">
															<div class="form-floating mb-3">
																<input class="form-control" type="text" name="" id="" maxlength="4" required>
																<label class="col-form-label" for="">Alior (pin:)</label>
															</div>
														</div>
													</div>
													<div class="col-auto">
														<div class="form-floating mb-3">
															<input class="form-control" type="text" name="" id="" required>
															<label class="col-form-label" for="">Alior (Numer karty:)</label>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-4">
										<div class="card">
											<div class="card-body">
												<div class="card-text">
													<div class="form-check mb-3">
														<input class="form-check-input" type="checkbox" id="boxCz" name="boxCz">
														<label class="form-check-label" for="boxCz">
															Flota (orlen)
														</label>
													</div>
													<div class="row">
														<div class="col-6">
															<div class="form-floating mb-3">
																<input class="form-control" type="date" name="" id="" required>
																<label class="col-form-label" for="">Flota (ważna do:)</label>
															</div>
														</div>
														<div class="col-6">
															<div class="form-floating mb-3">
																<input class="form-control" type="text" name="" id="" maxlength="4" required>
																<label class="col-form-label" for="">Flota (pin:)</label>
															</div>
														</div>
													</div>
													<div class="col-auto">
														<div class="form-floating mb-3">
															<input class="form-control" type="text" name="" id="" required>
															<label class="col-form-label" for="">Flota (Numer karty:)</label>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-4">
										<div class="card">
											<div class="card-body">
												<div class="card-text">
													<div class="form-check mb-3">
														<input class="form-check-input" type="checkbox" id="boxCz" name="boxCz">
														<label class="form-check-label" for="boxCz">
															E-100
														</label>
													</div>
													<div class="row">
														<div class="col-6">
															<div class="form-floating mb-3">
																<input class="form-control" type="month" name="" id="" required>
																<label class="col-form-label" for="">E-100 (ważna do:)</label>
															</div>
														</div>
														<div class="col-6">
															<div class="form-floating mb-3">
																<input class="form-control" type="text" name="" id="" maxlength="4" required>
																<label class="col-form-label" for="">E-100 (pin:)</label>
															</div>
														</div>
													</div>
													<div class="col-auto">
														<div class="form-floating mb-3">
															<input class="form-control" type="text" name="" id="" required>
															<label class="col-form-label" for="">E-100 (Numer karty:)</label>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>-->
					<div class="card-body">
						<div class="card-text">
							<div class="row">
								<div class="card mb-3 col-xl-8 col-lg-12">
									<div class="card-body">
										<div class="card-text">
											<label class="form-label card-title">Dokumenty</label>
											<div class="row">
												<div class="col-lg-6 col-sm-12">
													<div class="form-floating mb-3">
														<input
															class="form-control"
															type="date"
															name="autocassco"
															[(ngModel)]="data.documents.autocassco.endDate"
															id="autocassco"
															required
														/>
														<label class="col-form-label" for="autocassco"
															>AC (Ważny do:)</label
														>
													</div>
												</div>
												<div class="col-lg-6 col-sm-12">
													<div class="form-floating mb-3">
														<input
															class="form-control"
															type="date"
															name="license"
															[(ngModel)]="data.documents.license.endDate"
															id="license"
															required
														/>
														<label class="col-form-label" for="license"
															>Licencja (Ważny do:)</label
														>
													</div>
												</div>
												<div class="col-lg-6 col-sm-12">
													<div class="form-floating mb-3">
														<input
															class="form-control"
															type="date"
															name="authToUse"
															id="authToUse"
															[(ngModel)]="data.documents.authtouse.endDate"
														/>
														<label class="col-form-label" for="authToUse"
															>Upoważenienie do użytkowania</label
														>
													</div>
												</div>
												<div class="col-lg-6 col-sm-12">
													<div class="form-floating mb-3">
														<input
															class="form-control"
															type="date"
															name="greencard"
															[(ngModel)]="data.documents.greencard.endDate"
															id="greencard"
														/>
														<label class="col-form-label" for="greencard"
															>Zielona Karta (Ważny do:)</label
														>
													</div>
												</div>
												<div class="col-lg-6 col-sm-12">
													<div class="form-floating mb-3">
														<input
															class="form-control"
															type="date"
															name="insuranceEndDate"
															[(ngModel)]="data.documents.insurance.endDate"
															id="insurance"
														/>
														<label class="col-form-label" for=""
															>Ubezpieczenie (Ważny do:)</label
														>
													</div>
												</div>
												<div class="col-lg-6 col-sm-12">
													<div class="form-floating mb-3">
														<input
															class="form-control"
															type="date"
															name="inspectionEndDate"
															[(ngModel)]="data.documents.inspection.endDate"
															id="inspection"
														/>
														<label class="col-form-label" for=""
															>Badanie techniczne (ważny do:)</label
														>
													</div>
												</div>
												<div class="col-lg-6 col-sm-12">
													<div class="form-floating mb-3">
														<input class="form-control" type="date" name="" id="" />
														<label class="col-form-label" for=""
															>Zezwolenie na wahadło (Ważny do:)</label
														>
													</div>
												</div>
												<div class="col-lg-6 col-sm-12">
													<div class="form-floating mb-3">
														<input
															class="form-control"
															type="date"
															id="tachographLegalization"
															name="tachographLegalization"
															[(ngModel)]="data.documents.tachographLegalization.endDate"
														/>
														<label for="tachographLegalization"
															>Legalizacja tacho (ważny do:)</label
														>
													</div>
												</div>
												<div class="col-lg-6 col-sm-12">
													<div class="form-floating mb-3">
														<input
															class="form-control"
															type="date"
															id="vignetteHungary"
															name="vignetteHungary"
															[(ngModel)]="data.documents.vignetteHungary.endDate"
														/>
														<label for="tachographLegalization"
															>Winieta węgierska (Ważny do:)</label
														>
														<label for="vignetteHungary">Winieta węgierska</label>
													</div>
												</div>
												<div class="col-lg-6 col-sm-12">
													<div class="form-floating mb-3">
														<select
															class="form-control"
															id="licenseCompany"
															[(ngModel)]="data.documents.license.company"
															name="licenseCompany"
														>
															<option
																value="{{ item.id }}"
																*ngFor="let item of parameters.companies"
															>
																{{ item.name }}
															</option>
														</select>
														<label for="licenseCompany">Licencja na spółkę</label>
													</div>
												</div>
												<div class="col-lg-6 col-sm-12">
													<div class="form-floating mb-3">
														<select
															class="form-control"
															id="certificate100km"
															[(ngModel)]="data.documents.certificate100km.checkDocument"
															name="certificate100km"
														>
															<option value="2">Nie</option>
															<option value="1">Tak</option>
														</select>
														<label for="certificate100km">Badanie na 100km</label>
													</div>
												</div>
												<div class="col-lg-6 col-sm-12">
													<div class="form-floating mb-3">
														<select
															class="form-control"
															id="interBus"
															[(ngModel)]="data.documents.interBus.checkDocument"
															name="interBus"
														>
															<option value="2">Nie</option>
															<option value="1">Tak</option>
														</select>
														<label for="interBus">Interbus</label>
													</div>
												</div>
												<div class="col-lg-6 col-sm-12">
													<div class="form-floating mb-3">
														<select
															class="form-control"
															id="greenBook"
															[(ngModel)]="data.documents.greenBook.checkDocument"
															name="greenBook"
														>
															<option value="2">Nie</option>
															<option value="1">Tak</option>
														</select>
														<label for="greenBook">Zielona książka</label>
													</div>
												</div>
												<div class="col-lg-6 col-sm-12">
													<div class="form-floating mb-3">
														<select
															class="form-control"
															id="pinCards"
															[(ngModel)]="data.documents.pinCards.checkDocument"
															name="pinCards"
														>
															<option value="2">Nie</option>
															<option value="1">Tak</option>
														</select>
														<label for="pinCards">Piny do kart</label>
													</div>
												</div>
												<div>
													<div>
														<input
															class="form-check-input"
															type="checkbox"
															id="registrationCard"
															[checked]="data.documents.registrationcard.checkDocument"
															[(ngModel)]="data.documents.registrationcard.checkDocument"
															name="registrationcard"
														/>
														<!-- <input class="form-control" type="date" name="registrationcard" [(ngModel)]="data.documents.registrationcard.endDate" id="registrationCard" required> -->
														<label class="col-form-label" for="registrationcard">
															Brak miejsca na pieczątki w dowodzie rejestracyjny
														</label>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="card mb-3 col-xl-4 col-lg-12">
									<div class="card-body">
										<div class="card-text">
											<label class="form-label card-title">Steuer'y</label>
											<div class="row">
												<div class="col-6">
													<div class="form-check mb-3">
														<input
															class="form-check-input"
															type="checkbox"
															id="stAt"
															[checked]="data.documents.stAt.checkDocument"
															[(ngModel)]="data.documents.stAt.checkDocument"
															name="stAt"
														/>
														<label class="form-check-label" for="stAt"> Austria </label>
													</div>
												</div>
												<div class="col-6">
													<div class="form-check mb-3">
														<input
															class="form-check-input"
															type="checkbox"
															id="stBe"
															[checked]="data.documents.stBe.checkDocument"
															[(ngModel)]="data.documents.stBe.checkDocument"
															name="stBe"
														/>
														<label class="form-check-label" for="stBe"> Belgia </label>
													</div>
												</div>
												<div class="col-6">
													<div class="form-check mb-3">
														<input
															class="form-check-input"
															type="checkbox"
															id="stCh"
															[checked]="data.documents.stCh.checkDocument"
															[(ngModel)]="data.documents.stCh.checkDocument"
															name="stCh"
														/>
														<label class="form-check-label" for="stCh"> Chorwacja </label>
													</div>
												</div>
												<div class="col-6">
													<div class="form-check mb-3">
														<input
															class="form-check-input"
															type="checkbox"
															id="stDk"
															[checked]="data.documents.stDk.checkDocument"
															[(ngModel)]="data.documents.stDk.checkDocument"
															name="stDk"
														/>
														<label class="form-check-label" for="stDk"> Dania </label>
													</div>
												</div>
												<div class="col-6">
													<div class="form-check mb-3">
														<input
															class="form-check-input"
															type="checkbox"
															id="stSlo"
															[checked]="data.documents.stSlo.checkDocument"
															[(ngModel)]="data.documents.stSlo.checkDocument"
															name="stSlo"
														/>
														<label class="form-check-label" for="stSlo"> Słowenia </label>
													</div>
												</div>
												<div class="col-6">
													<div class="form-check mb-3">
														<input
															class="form-check-input"
															type="checkbox"
															id="stDeinfo"
															[checked]="data.documents.stDeinfo.checkDocument"
															[(ngModel)]="data.documents.stDeinfo.checkDocument"
															name="stDeinfo"
														/>
														<label class="form-check-label" for="stDeinfo">
															Niemcy-info
														</label>
													</div>
												</div>
												<div class="col-6">
													<div class="form-check mb-3">
														<input
															class="form-check-input"
															type="checkbox"
															id="stDe"
															[checked]="data.documents.stDe.checkDocument"
															[(ngModel)]="data.documents.stDe.checkDocument"
															name="stDe"
														/>
														<label class="form-check-label" for="stDe"> Niemcy </label>
													</div>
												</div>
												<div class="col-12">
													<div class="form-floating mb-3">
														<input
															class="form-control"
															type="date"
															name="stDeEndDate"
															[(ngModel)]="data.documents.stDe.endDate"
															id="stDeEndDate"
														/>
														<label class="col-form-label" for="stDeEndDate"
															>Niemcy (ważny do:)</label
														>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</fieldset>
			</div>
			<div class="tab-pane fade" id="facilities" role="tabpanel" aria-labelledby="facilities-tab">
				<fieldset [disabled]="pageFunction !== 'add' && !editable">
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="checkHook"
							[(ngModel)]="data.documents.hook.checkHook"
							name="checkHook"
						>
							<option value="1">Tak</option>
							<option value="2">Nie</option>
							<option value="3">Możliwość podłączenia</option>
							<option value="4">W ostateczności</option>
						</select>
						<label for="busType">Hak</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="backpack"
							[(ngModel)]="data.documents.backpack.checkDocument"
							name="backpack"
						>
							<option value="1">Tak</option>
							<option value="2">Nie</option>
							<option value="3">Możliwość podłączenia</option>
						</select>
						<label for="backpack">Plecak</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="workshopBox"
							[(ngModel)]="data.documents.workshopBox.checkDocument"
							name="workshopBox"
						>
							<option value="1">Tak</option>
							<option value="2">Nie</option>
						</select>
						<label for="workshopBox">Skrzynia warsztatowa</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="chains"
							[(ngModel)]="data.documents.chains.checkDocument"
							name="chains"
						>
							<option value="1">Tak</option>
							<option value="2">Nie</option>
						</select>
						<label for="chains">Łańcuchy</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="aidKit"
							[(ngModel)]="data.documents.aidKit.checkDocument"
							name="aidKit"
						>
							<option value="1">Tak</option>
							<option value="2">Nie</option>
						</select>
						<label for="aidKit">Apteczka</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="fireExtinguisher"
							[(ngModel)]="data.documents.fireExtinguisher.checkDocument"
							name="fireExtinguisher"
						>
							<option value="1">Tak</option>
							<option value="2">Nie</option>
						</select>
						<label for="fireExtinguisher">Gaśnica</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="toiletStatus"
							[(ngModel)]="data.documents.toiletStatus.checkDocument"
							name="toiletStatus"
						>
							<option value="1">Tak</option>
							<option value="2">Nie</option>
						</select>
						<label for="toiletStatus">Sprawne WC</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="seatsType"
							[(ngModel)]="data.documents.seatsType.checkDocument"
							name="seatsType"
						>
							<option value="1">300</option>
							<option value="2">500</option>
						</select>
						<label for="seatsType">Typ siedzeń</label>
					</div>
					<div class="form-floating mb-3">
						<input
							class="form-control"
							type="number"
							name="distanceSeats"
							id="distanceSeats"
							[(ngModel)]="data.documents.distanceSeats.number"
						/>
						<label for="distanceSeats">Odległość między siedzeniami</label>
					</div>
					<div class="form-floating mb-3">
						<input
							class="form-control"
							type="number"
							name="distanceHeadrests"
							id="distanceHeadrests"
							[(ngModel)]="data.documents.distanceHeadrests.number"
						/>
						<label for="distanceHeadrests">Odległość między zagłówkami</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="chaiseLongue"
							[(ngModel)]="data.documents.chaiseLongue.checkDocument"
							name="chaiseLongue"
						>
							<option value="1">Tak</option>
							<option value="2">Nie</option>
						</select>
						<label for="chaiseLongue">Szezlong</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="internet"
							[(ngModel)]="data.documents.internet.checkDocument"
							name="internet"
						>
							<option value="1">Tak</option>
							<option value="2">Nie</option>
						</select>
						<label for="internet">Internet</label>
					</div>
				</fieldset>
			</div>
			<div class="tab-pane fade" id="equipments" role="tabpanel" aria-labelledby="equipments-tab">
				<fieldset [disabled]="pageFunction !== 'add' && !editable">
					<div class="card-body">
						<div class="card-text">
							<label class="form-label card-title">Boxy</label>
							<div class="row">
								<div class="col-6">
									<div class="form-check mb-3">
										<input
											class="form-check-input"
											type="checkbox"
											[(ngModel)]="data.documents.box.checkDocument"
											id="box"
											name="box"
										/>
										<label class="form-check-label" for="box"> Box Uniwersalny </label>
									</div>
								</div>
								<div class="col-6">
									<div class="form-check mb-3">
										<input
											class="form-check-input"
											type="checkbox"
											[(ngModel)]="data.documents.boxCz.checkDocument"
											id="boxCz"
											name="boxCz"
										/>
										<label class="form-check-label" for="boxCz"> Box Czechy (CZ) </label>
									</div>
								</div>
								<div class="col-6">
									<div class="form-check mb-3">
										<input
											class="form-check-input"
											type="checkbox"
											[(ngModel)]="data.documents.boxSk.checkDocument"
											id="boxSk"
											name="boxSk"
										/>
										<label class="form-check-label" for="boxSk"> Box Słowacja (SK) </label>
									</div>
								</div>
								<div class="col-6">
									<div class="form-check mb-3">
										<input
											class="form-check-input"
											type="checkbox"
											[(ngModel)]="data.documents.boxSi.checkDocument"
											id="boxSi"
											name="boxSi"
										/>
										<label class="form-check-label" for="boxSi"> Box Słowenia (SI) </label>
									</div>
								</div>
								<div class="col-6">
									<div class="form-check mb-3">
										<input
											class="form-check-input"
											type="checkbox"
											[(ngModel)]="data.documents.boxAt.checkDocument"
											id="boxAt"
											name="boxAt"
										/>
										<label class="form-check-label" for="boxAt"> Box Austria (AT) </label>
									</div>
								</div>
								<div class="col-6">
									<div class="form-check mb-3">
										<input
											class="form-check-input"
											type="checkbox"
											[(ngModel)]="data.documents.boxXs.checkDocument"
											id="boxXs"
											name="boxXs"
										/>
										<label class="form-check-label" for="boxXs"> Box Serbia (SB) </label>
									</div>
								</div>
								<div class="col-6">
									<div class="form-check mb-3">
										<input
											class="form-check-input"
											type="checkbox"
											[(ngModel)]="data.documents.boxPl.checkDocument"
											id="boxPl"
											name="boxPl"
										/>
										<label class="form-check-label" for="boxPl"> Box Polska (PL) </label>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="cafeBar"
							[(ngModel)]="data.documents.cafeBar.checkDocument"
							name="cafeBar"
						>
							<option value="1">Tak</option>
							<option value="2">Nie</option>
						</select>
						<label for="cafeBar">Cafe bar</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="monitors"
							[(ngModel)]="data.documents.monitors.number"
							name="monitors"
						>
							<option value="1">0</option>
							<option value="2">1</option>
							<option value="3">2</option>
							<option value="4">3</option>
							<option value="5">4</option>
						</select>
						<label for="monitors">Monitory</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="sockets"
							[(ngModel)]="data.documents.sockets.number"
							name="sockets"
						>
							<option value="1">0</option>
							<option value="2">1</option>
							<option value="3">2</option>
						</select>
						<label for="sockets">Gniazdka (na ławkę)</label>
					</div>
					<div class="form-floating mb-3">
						<select class="form-control" id="usb" [(ngModel)]="data.documents.usb.number" name="usb">
							<option value="1">0</option>
							<option value="2">1</option>
							<option value="3">2</option>
						</select>
						<label for="usb">USB (na ławkę)</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="wifi"
							[(ngModel)]="data.documents.wifi.checkDocument"
							name="wifi"
						>
							<option value="1">Tak</option>
							<option value="2">Nie</option>
						</select>
						<label for="wifi">WI-FI</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="multimediaSystem"
							[(ngModel)]="data.documents.multimediaSystem.checkDocument"
							name="multimediaSystem"
						>
							<option value="1">Tak</option>
							<option value="2">Nie</option>
						</select>
						<label for="multimediaSystem">System multimedialny</label>
					</div>
					<div class="form-floating mb-3">
						<textarea
							class="form-control"
							type="text"
							name="multimediaSystemDescription"
							id="multimediaSystemDescription"
							[(ngModel)]="data.documents.multimediaSystemDescription.company"
						></textarea>
						<label for="multimediaSystem">System multimedialny - uwagi</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="microphone"
							[(ngModel)]="data.documents.microphone.checkDocument"
							name="microphone"
						>
							<option value="1">Tak</option>
							<option value="2">Nie</option>
						</select>
						<label for="microphone">Mikrofon</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="safe"
							[(ngModel)]="data.documents.safe.checkDocument"
							name="safe"
						>
							<option value="1">Tak</option>
							<option value="2">Nie</option>
						</select>
						<label for="safe">Sejf (z kluczem)</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="movies"
							[(ngModel)]="data.documents.movies.checkDocument"
							name="movies"
						>
							<option value="1">Tak</option>
							<option value="2">Nie</option>
						</select>
						<label for="movies">Filmy</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="headphones"
							[(ngModel)]="data.documents.headphones.checkDocument"
							name="headphones"
						>
							<option value="1">Tak</option>
							<option value="2">Nie</option>
						</select>
						<label for="headphones">Słuchawki</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="vest"
							[(ngModel)]="data.documents.vest.checkDocument"
							name="vest"
						>
							<option value="1">Tak</option>
							<option value="2">Nie</option>
						</select>
						<label for="vest">Kamizelka</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="board"
							[(ngModel)]="data.documents.board.checkDocument"
							name="board"
						>
							<option value="1">Tak</option>
							<option value="2">Nie</option>
						</select>
						<label for="board">Tablica dla dzieci</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="libra"
							[(ngModel)]="data.documents.libra.checkDocument"
							name="libra"
						>
							<option value="1">Tak</option>
							<option value="2">Nie</option>
						</select>
						<label for="libra">Waga do bagażu</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="tachoRolls"
							[(ngModel)]="data.documents.tachoRolls.checkDocument"
							name="tachoRolls"
						>
							<option value="1">Tak</option>
							<option value="2">Nie</option>
						</select>
						<label for="tachoRolls">Rolki do tacho</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="butterflies"
							[(ngModel)]="data.documents.butterflies.checkDocument"
							name="butterflies"
						>
							<option value="1">Tak</option>
							<option value="2">Nie</option>
						</select>
						<label for="butterflies">Motylki</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="busDescription"
							[(ngModel)]="data.documents.busDescription.checkDocument"
							name="busDescription"
						>
							<option value="1">Tak</option>
							<option value="2">Nie</option>
						</select>
						<label for="busDescription">Opisy autokarów</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-control"
							id="seatsDisplacement"
							[(ngModel)]="data.documents.busDescription.checkDocument"
							name="seatsDisplacement"
						>
							<option value="1">Tak</option>
							<option value="2">Nie</option>
						</select>
						<label for="seatsDisplacement">Rozkład siedzeń</label>
						<a
							href="https://docs.google.com/spreadsheets/d/1fbyZ3wfnHpgo8062ZWwlXMT8fABSUdAms7KxAdv2ZNY/edit#gid=2028171202"
							>Plik z rozkladem siedzeń</a
						>
					</div>
				</fieldset>
			</div>
			<div class="tab-pane fade" id="task" role="tabpanel" aria-labelledby="task-tab">
				<app-php-tasks objType="vehicles" [objId]="data.id"></app-php-tasks>
			</div>
			<div class="tab-pane fade" id="confirmed" role="tabpanel" aria-labelledby="confirmed-tab">
				<app-dynamic-table
					module="vehicleConfirmed"
					[elements]="data.confirmed"
					[tableRows]="tableRows"
					[haveAnyFilters]="false"
				></app-dynamic-table>
			</div>
			<div class="tab-pane fade" id="layout" role="tabpanel" aria-labelledby="layout-tab">
				<div class="form-floating mb-3">
					<select
						[disabled]="!editable"
						class="form-control"
						id="seatsLayout"
						name="seatsLayout"
						[(ngModel)]="seatLayout"
					>
						<option [value]="item.id" *ngFor="let item of seatLayouts()">
							{{ item.name }}
						</option>
					</select>
					<label class="form-label">Układ siedzeń</label>
				</div>
			</div>
		</div>
	</div>
</div>
